module.exports = __webpack_public_path__ + "static/media/meritus-6.f28a734e.jpg";